import {ShowWallets} from './show-wallets';

export default ShowWallets;
